import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckSmall = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "-8 -8 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 0C5.3835 0 0 5.3835 0 12C0 18.6165 5.3835 24 12 24C18.6165 24 24 18.6165 24 12C24 5.3835 18.6165 0 12 0ZM12 21C7.0365 21 3 16.9635 3 12C3 7.0365 7.0365 3 12 3C16.9635 3 21 7.0365 21 12C21 16.9635 16.9635 21 12 21Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.4999 17.1209L5.37891 11.9999L7.49991 9.87891L10.4999 12.8789L16.4999 6.87891L18.6209 8.99991L10.4999 17.1209Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgCheckSmall);
export default ForwardRef;
